export default function ShimmerLoaderSeat() {
  return (
    <div className="relative overflow-hidden bg-gray-200 rounded-md h-20 w-full mb-2">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gray-300 to-transparent animate-shimmer" />
    </div>
  );
}